import '../scss/main.scss';

import { hamburger } from './components/hamburger';
import { followMenu } from './components/followMenu';
import { slider } from './components/slider';
import { makeSpaceInNav } from './components/makeSpaceInNav';
import { lightbox } from './components/lightbox';

/* Defining Site URL for images, so the website works on subfolder wordpress instances as well as global/absolute instances */
if (typeof themeSettings !== 'undefined') {
  __webpack_public_path__ = `${themeSettings.baseUrl}/wp-content/themes/pod-aniolami/dist/images/`;
}
document.addEventListener("DOMContentLoaded", () => {
  slider();
  require("fslightbox");
  makeSpaceInNav();
  followMenu();
  hamburger();
  lightbox();
}) 
